import usePage from '../../hooks/usePage';
import { getComponentFromName } from '../../lib/utils';

import ResultsDefault from './ResultsDefault';
import * as Components from './results-index';

function ResultsPage() {
    const { page = null } = usePage();
    const { layout = null } = page || {};
    const Component = getComponentFromName(Components, layout, ResultsDefault) || null;
    return Component !== null ? <Component page={page} /> : null;
}

export default ResultsPage;
